export default {
    light: '#ff9586',
    main: '#ff6259',
    dark: '#9E332D',
    contrastText: '#fff'
};
